<template>
  <tr @click="goToPage()">
    <td class="text-no-wrap">
      {{ props.item.slug }}
    </td>
    <td class="text-xs-left">
      <a
        href=""
        @click.prevent="goToPage()">{{ props.item.name }}</a>
    </td>
    <td>
      <v-chip
        small
        color="orange"
      >
        {{ props.item.type | beautify }}
      </v-chip>
    </td>
    <td class="text-xs-center">
      <v-icon>{{ props.item.protected ? 'check' : 'close' }}</v-icon>
    </td>
    <td class="text-no-wrap">{{ props.item.created_at | timezone }}</td>
    <td class="text-no-wrap">{{ props.item.updated_at | timezone }}</td>
  </tr>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('cms/pages')

export default {
  name: 'PageDataTableRow',

  filters: {
    beautify: function (val) {
      return val.replace('_', ' ').toUpperCase()
    }
  },

  props: {
    props: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['templateCode'])
  },

  methods: {
    goToPage () {
      this.$router.push({ name: 'single-page', params: { id: this.props.item.id }, query: { code: this.templateCode } })
    }
  }
}
</script>
